import React, { createContext, useContext, useEffect, useState } from 'react';
import { useConfig } from '../../../contexts/config-context';
import { useElementProps } from '../../../contexts/element-props-context';
import useInitialAppointmentState from '../actions/initial-appointment-state';
import { initialDefaultState } from '../actions/initial-appointment-state/utils';
import { DataStatus, ErrorTypes } from '../appointment-state';
const AppointmentFieldContext = /*#__PURE__*/ createContext({
    appointmentState: {},
    setAppointmentState: ()=>{}
});
const NO_AVAILABILITY_STATE = {
    dataStatus: DataStatus.ERROR,
    error: {
        type: ErrorTypes.NO_AVAILABILITY_DATES_FOUND,
        message: 'No availability dates found'
    }
};
export const AppointmentContextProvider = ({ appointmentFieldProps, children })=>{
    const { isEditor, isComposer } = useConfig();
    const isNoAvailabilityState = useElementProps().appointment?.noAvailability === true;
    const [appointmentState, setAppointmentState] = useState(()=>initialDefaultState({
            appointmentFieldProps,
            isEditor,
            isComposer
        }));
    const initialAppointmentState = useInitialAppointmentState(appointmentFieldProps);
    useEffect(()=>{
        if (initialAppointmentState) {
            setAppointmentState({
                ...appointmentState,
                ...initialAppointmentState
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialAppointmentState
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentFieldContext.Provider, {
        value: {
            appointmentFieldProps,
            appointmentState: isNoAvailabilityState ? NO_AVAILABILITY_STATE : appointmentState,
            setAppointmentState: (nextState)=>{
                return setAppointmentState({
                    ...appointmentState,
                    ...nextState
                });
            }
        }
    }, children);
};
export const useAppointmentContext = ()=>useContext(AppointmentFieldContext);

//# sourceMappingURL=appointment-context.js.map